import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { twMerge } from 'tailwind-merge'

interface Props {
  twClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandList',
  props: {
    twClass: null
  },
  setup(__props: any) {

const props = __props as {
  twClass?: string
};



const baseClasses = 'max-h-[300px] overflow-y-auto overflow-x-hidden'
const mergedClasses = computed(() => twMerge(baseClasses, props.twClass))

return { __sfc: true,props, baseClasses, mergedClasses }
}

})